import { APIMethod, fetchData } from "@client";
import { DEFAULT_WORK_TYPE_COLOR } from "@utils";

export async function editCustomWorkTypeQuery(id, name, backgroundColor=DEFAULT_WORK_TYPE_COLOR) {
  const data = {
    id,
    name,
    backgroundColor,
  };
  const res = await fetchData(`/tags/${id}`, APIMethod.PUT, { data, mapRequestKeysToSnakeCase:false });
  return { ...data, removable: true, id: res.results.id };
}
